const VotesValue = ({ votes = {}, setVotes }) => {
  const handleInputChange = (key, field, value) => {
    const numericValue = value.replace(/[^0-9]/g, "");
    // If cleared, remove the field so the input shows empty ("")
    if (numericValue === "") {
      setVotes((prev) => {
        const nextKey = { ...(prev[key] || {}) };
        delete nextKey[field];

        // Keep the key present to keep the row visible
        return { ...prev, [key]: nextKey };
      });
      return;
    }

    // Otherwise, coerce to integer (fallback to 0 if invalid)
    const n = parseInt(numericValue, 10);
    setVotes((prev) => ({
      ...prev,
      [key]: {
        ...(prev[key] || {}),
        [field]: Number.isFinite(n) ? n : 0,
      },
    }));
  };

  return (
    <section className="mt-8 p-4 border rounded-md bg-blue-50">
      <h3 className="text-2xl font-semibold mb-4">Set Votes &amp; Values</h3>
      <div className="grid lg:grid-cols-2 gap-4">
        {Object.keys(votes || {}).map((key) => (
          <div
            key={key}
            className="flex flex-col lg:flex-row items-center justify-between gap-4 bg-white p-4 shadow-md border rounded-md"
          >
            {/* Votes Weight Input */}
            <div className="w-full lg:w-1/2">
              <label className="block text-sm lg:text-base font-semibold text-gray-800 mb-1">
                {key === "comment"
                  ? "1 comment = how many votes"
                  : `${key.charAt(0).toUpperCase() + key.slice(1)} Votes Weight`}
              </label>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={votes[key]?.votes ?? ""}
                onChange={(e) => handleInputChange(key, "votes", e.target.value)}
                onKeyDown={(e) => {
                  if (!/^\d$/.test(e.key) && !["Backspace","Delete","ArrowLeft","ArrowRight","Tab","Enter","Home","End"].includes(e.key) && !e.ctrlKey && !e.metaKey) e.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                className="w-full border border-gray-300 rounded-md px-4 py-2"
                placeholder="Enter votes weight"
              />
            </div>

            {/* Equal Sign */}
            <div className="hidden lg:block font-bold text-blue-500 text-xl mt-4">=</div>

            {/* Votes Value Input */}
            <div className="w-full lg:w-1/2">
              <label className="block text-sm lg:text-base font-semibold text-gray-800 mb-1">
                How many {key.charAt(0).toUpperCase() + key.slice(1)} Votes Value
              </label>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={votes[key]?.value ?? ""}
                onChange={(e) => handleInputChange(key, "value", e.target.value)}
                onKeyDown={(e) => {
                  if (!/^\d$/.test(e.key) && !["Backspace","Delete","ArrowLeft","ArrowRight","Tab","Enter","Home","End"].includes(e.key) && !e.ctrlKey && !e.metaKey) e.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                className="w-full border border-gray-300 rounded-md px-4 py-2"
                placeholder="Enter votes value"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default VotesValue;
